import { countries as countriesMap, type CountryIso2 } from '~/constants/countries';

const INSURANCE_AVAILABLE_IN_COUNTRIES: Partial<Record<CountryIso2, boolean>> = {
  [countriesMap.AS.iso2]: true,
  [countriesMap.CA.iso2]: true,
  [countriesMap.DE.iso2]: true,
  [countriesMap.ES.iso2]: true,
  [countriesMap.FR.iso2]: true,
  [countriesMap.GB.iso2]: true,
  [countriesMap.GU.iso2]: true,
  [countriesMap.IT.iso2]: true,
  [countriesMap.MP.iso2]: true,
  [countriesMap.NL.iso2]: true,
  [countriesMap.PR.iso2]: true,
  [countriesMap.US.iso2]: true,
  [countriesMap.VI.iso2]: true,
};

/**
 * Test if a given list of countries is eligible for insurance.
 *
 * @param {CountryIso2[]} countries - List of country codes
 */
export const isInsuranceAvailableForCountries = (countries: CountryIso2[]): boolean => {
  if (!countries.length) return false;

  return countries.every((country) => INSURANCE_AVAILABLE_IN_COUNTRIES[country]);
};
